export function Home() {
    return null;
}
